/**
 * Bordure des champs de saisie des pages publiques (adhésion, billetterie,
 * boutique) : UNE seule bordure, grise au repos, noire au focus — jamais de
 * halo en plus.
 *
 * Karim 2026-09-29 : « pourquoi quand on focus un input ça fait 2 bordures
 * noires dont une floue ? » — l'adhésion ajoutait autour de la bordure noire un
 * anneau noir à 20 % (le « flou »), la billetterie passait en gris, le
 * formulaire des questions en bleu avec halo : trois styles pour un même geste.
 */

/** Champ au repos / au focus. */
export const BORDURE_CHAMP_PUBLIC =
  "border border-gray-200 dark:border-[#262626] focus:outline-none focus:border-[#212121] dark:focus:border-white";

/** Champ en erreur : rouge, y compris au focus. */
export const BORDURE_CHAMP_PUBLIC_ERREUR =
  "border border-red-500 dark:border-red-500 focus:outline-none focus:border-red-500";

/** Même règle pour les `UInput` (Nuxt UI dessine sa bordure avec `ring`). */
export const UI_CHAMP_PUBLIC =
  "rounded-xl ring-gray-200 dark:ring-[#262626] focus-visible:ring-1 focus-visible:ring-[#212121] dark:focus-visible:ring-white";

/** `UInput` en erreur. */
export const UI_CHAMP_PUBLIC_ERREUR =
  "rounded-xl ring-red-500 dark:ring-red-500 focus-visible:ring-1 focus-visible:ring-red-500";
